import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/layout/Header";
import ScrollToTop from "./components/layout/ScrollToTop";
import Home from "./pages/Home";
import RowdyParty from "./pages/RowdyParty";
import SereneBliss from "./pages/SereneBliss";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      
      {/* ✅ No props needed */}
      <Header />

      <div
        style={{
          marginTop: "70px",
          backgroundColor: "white",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product/rowdy-party" element={<RowdyParty />} />
          <Route path="/product/serene-bliss" element={<SereneBliss />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;